import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import API_BASE_DISCOVER from "../../config_Discover";

function Discover() {
  const [compound, setCompound] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleAnalyzeClick = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_DISCOVER}/api/analyze`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ compound }),
      });
      if (!res.ok) throw new Error("Failed to start analysis");
      const { job_id } = await res.json();

      // Poll for result
      const interval = setInterval(async () => {
        const pollRes = await fetch(
          `${API_BASE_DISCOVER}/api/result?job_id=${job_id}`
        );
        const pollData = await pollRes.json();
        if (pollData.status === "ready") {
          clearInterval(interval);
          setLoading(false);
          navigate("/biothread/discover/results", {
            state: {
              compound,
              result: pollData.result,
            },
          });
        }
      }, 3000);
    } catch (err) {
      setLoading(false);
      alert(err.message || "Analysis error");
    }
  };

  return (
    // Outer container to center the card
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "60vh",
        px: 2,
        // bgcolor: "background.default", // optional background
      }}
    >
      {/* Your existing form box */}
      <Box
        component="form"
        onSubmit={handleAnalyzeClick}
        sx={{
          maxWidth: 520,
          width: "100%",
          p: 4,
          borderRadius: 2,
          boxShadow: 1,
          backgroundColor: "rgba(255,255,255,0.8)", // subtle background to blend with bg
          backdropFilter: "blur(8px)", // optional blur for smooth blending
        }}
      >
        {/* Title */}
        <Typography
          variant="h5"
          fontWeight={700}
          textAlign="center"
          gutterBottom
          sx={{
            background: "linear-gradient(90deg, #1e3a8a, #3b82f6)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Discover
        </Typography>

        {/* Subtitle */}
        <Typography
          variant="body2"
          color="text.secondary"
          textAlign="center"
          mb={3}
        >
          Identifies the most heavily researched biological outcome based on
          PubMed keyword frequency
        </Typography>

        {/* Input */}
        <TextField
          fullWidth
          label="Compound name *"
          value={compound}
          onChange={(e) => setCompound(e.target.value)}
          helperText="Example: Aspirin, Ibuprofen, Paracetamol"
          sx={{
            mb: 3,
            "& .MuiOutlinedInput-root": {
              borderRadius: 999,
              backgroundColor: "#F9FAFB",
            },
          }}
        />

        {/* Button */}
        <Button
          type="submit"
          fullWidth
          disabled={loading}
          sx={{
            py: 1.6,
            borderRadius: 999,
            fontWeight: 600,
            fontSize: "1rem",
            textTransform: "none",
            background: "linear-gradient(90deg, #1e3a8a, #3b82f6)",
            color: "#fff",
            transition: "background 0.3s",
            "&:hover": {
              background: "linear-gradient(90deg, #172554, #2563eb)",
            },
          }}
        >
          {loading ? (
            <CircularProgress size={24} sx={{ color: "white" }} />
          ) : (
            "Analyze"
          )}
        </Button>
      </Box>
    </Box>
  );
}

export default Discover;